import { INVOICE_SERVICE, AVTALA_BACKEND } from "@/store/constants";

export default {
  status({ dispatch }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.get("/fortnox"))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  activate({ dispatch }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.post("/fortnox"))
        .then((response) => {
          console.log(response);
          const { redirect, error } = response.data;
          if (error) {
            throw new Error(error);
          }
          resolve(redirect);
        })
        .catch((err) => reject(err));
    });
  },

  uninstall({ dispatch }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.delete("/fortnox"))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  activation({ dispatch }, args) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.post("/fortnox/activation", args))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getCompanyInformation({ dispatch }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.get("/fortnox/companyinformation"))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  syncCustomers({ dispatch }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", AVTALA_BACKEND, { root: true })
        .then((api) => api.post("/contact/fortnox/customers"))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  syncCustomer({ dispatch }, number) {
    return new Promise(function (resolve, reject) {
      dispatch("API", AVTALA_BACKEND, { root: true })
        .then((api) => api.post("/contact/fortnox/customers", { number }))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getAllCustomers({ dispatch }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.get("/customers"))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getCustomersByName({ dispatch }, name) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.get("/customers?name=" + encodeURIComponent(name)))
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getCustomersByEmail({ dispatch }, { name, email }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) =>
          api.get(
            "/customers?name=" +
              encodeURIComponent(name) +
              "&email=" +
              encodeURIComponent(email)
          )
        )
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getCustomersByPostalCode({ dispatch }, { name, postalCode }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) =>
          api.get(
            "/customers?name=" +
              encodeURIComponent(name) +
              "&postalCode=" +
              encodeURIComponent(postalCode)
          )
        )
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getCustomer({ dispatch }, number) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.get("/customers/" + encodeURIComponent(number)))
        .then((response) => resolve(response.data))
        .catch((err) => resolve(null));
    });
  },

  syncContract({ dispatch }, { view, category, number, offset }) {
    return new Promise(function (resolve, reject) {
      dispatch("API", AVTALA_BACKEND, { root: true })
        .then((api) =>
          api.post("/contract/fortnox/import", { view, category, number, offset })
        )
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getImportStatus({ dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch("API", AVTALA_BACKEND, { root: true })
        .then((api) =>
          api.get("/contract/fortnox/import/" + encodeURIComponent(id))
        )
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  abortImport({ dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch("API", AVTALA_BACKEND, { root: true })
        .then((api) =>
          api.delete("/contract/fortnox/import/" + encodeURIComponent(id))
        )
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
  },

  getContract({ dispatch }, number) {
    return new Promise(function (resolve, reject) {
      dispatch("API", INVOICE_SERVICE, { root: true })
        .then((api) => api.get("/contracts/" + encodeURIComponent(number)))
        .then((response) => resolve(response.data))
        .catch((err) => resolve(null));
    });
  },
  /*
  createInvoice({ dispatch }, id) {
    return new Promise(function (resolve, reject) {
      dispatch('API', INVOICE_SERVICE, { root: true })
        .then(api => api.post('/invoices/' + encodeURIComponent(number)))
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
  */
};
